import { Component, OnInit, Inject, ViewChild, AfterViewInit, Input, ViewEncapsulation, ElementRef, ChangeDetectorRef} from '@angular/core';
import { LfRepoTreeService, EntryTreeNode } from '../services/resource/lf-repo-tree.service';
import { RepositoryService } from '../services/resource/repository.service';
import { BaseDialog, Dialog } from '@lf-web-components/lf-dialog-library';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { EventSystemService } from '@lf-web-components/lf-event-library';
import { LfToastMessage, LfMessageToastTypes } from '@lf-web-components/lf-message-toast';
import { generateToast, lfFilesetLocalize } from '../shared/utils';
import { NoopScrollStrategy } from '@angular/cdk/overlay';
import { LocalizePipe } from '@lf-web-components/lf-common-utils-library';
import { LfRepositoryBrowserComponent, LfTreeNode } from '@laserfiche/lf-ui-components/lf-repository-browser';

@Component({
  selector: 'lf-file-browser-dialog',
  templateUrl: './file-browser-dialog.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./file-browser-dialog.component.css', '../global-styles.css', '../lf-button-styles.css', '../lf-custom-mat-styles.css'],
  providers: [RepositoryService]
})
@Dialog({
  name: 'FileBrowserDialog',
  height: '575px',
  width: '500px',
  dialogConfig: {
    scrollStrategy: new NoopScrollStrategy()
  }
})
export class FileBrowserDialogComponent extends BaseDialog implements OnInit, AfterViewInit {
  isLoading: boolean;
  toastMessages: LfToastMessage[] = [];
  lfFilesetLocalizeHelper = lfFilesetLocalize;

  @ViewChild(LfRepositoryBrowserComponent) lfFileExplorerComponent!: LfRepositoryBrowserComponent;
  selectedNodes: EntryTreeNode[] = undefined;
  isSelectedNodeFile: boolean;
  searchString: string = '';
  selectable = this._selectable.bind(this);

  private _lastValueSearched = '';

  constructor(eventSystem: EventSystemService,
    dialogRef: MatDialogRef<BaseDialog>,
    @Inject(MAT_DIALOG_DATA) protected data: any,
    private lfRepoTreeService: LfRepoTreeService,
    private repositoryService: RepositoryService,
    private localizePipe: LocalizePipe) { 
    super(eventSystem, dialogRef, data);
  }

  ngOnInit() {
    this.isLoading = true;
    this.lfRepoTreeService.setRepositoryId(this.data.id);
    this.lfRepoTreeService.setSourceFolder(this.data.sourceFolder);
    this.lfRepoTreeService.filterString = this.searchString;
  }

  async ngAfterViewInit() {
    try{
      await Promise.all([
        this.lfFileExplorerComponent.initAsync(this.lfRepoTreeService),
        this.repositoryService.getRepositoryEntryProp(this.data.id, '1').toPromise()
      ]);
      this.isLoading = false;
    }
    catch(error){
      switch(error.status){
        case 403:{
          this.toastMessages = [ generateToast(LfMessageToastTypes.Error, this.localizePipe.transform('lf_fileset_forbidden_access_error_message', lfFilesetLocalize)) ];
          break;
        }
        default: {
          this.toastMessages = [ generateToast(LfMessageToastTypes.Error,  this.localizePipe.transform('lf_fileset_failed_to_query_entries_error_message', lfFilesetLocalize)) ];
          break;
        }
      }
    }
  }

  onClose(){
    this.dialogRef.close();
  }

  onConfirm(){
    this.dialogRef.close(this.selectedNodes);
  }

  onComponentNodesSelected(event: EntryTreeNode[]) {
    const nodes = event;
    if (nodes && nodes.length) {
      this.selectedNodes = nodes;
      this.isSelectedNodeFile = true;
    } else {
      this.isSelectedNodeFile = false;
    }
  }

  async onSearchValueChange() {
    if (this._lastValueSearched === this.searchString) {
      return;
    }
    this._lastValueSearched = this.searchString;
    this.lfRepoTreeService.filterString = this.searchString;
    await this.lfFileExplorerComponent?.refreshAsync();
  }

  private _selectable(node: LfTreeNode): Promise<boolean> {
    if (node.isContainer) { return Promise.resolve(false); }
    return Promise.resolve(true); 
  }
}
